/*!
* jQuery Sticky Alert v0.1.6
* https://github.com/tlongren/jquery-sticky-alert
*
* Copyright 2018 Tyler Longren
* Released under the MIT license.
* http://jquery.org/license
*
* Date: January 30, 2018
*/
(function($){

  $.fn.extend({

    stickyalert: function(options) {
      var defaults = {
        cookieRememberDays: '1' // in days
      };

      var options = $.extend(defaults, options);
      return this.each(function() {
        if (document.cookie.indexOf("jqsa") >= 0) {
          $('#topbar').hide();
          $('#topbar').addClass('topbar-is-closed');
          $('#page-wrapper').addClass('topbar-is-hidden');
        }

        else {
          // show the alert
          $('#topbar').delegate('.topbar--close', 'click', function(event) {
            event.preventDefault();
            $(this).closest('#topbar').slideUp('slow', function(event){
              $(this).hide()
              $('#topbar').addClass('topbar-is-closed');
              $('#page-wrapper').addClass('topbar-is-hidden');
              
              
              // set a new cookie
              if (options.cookieRememberDays === 0) {
                // do nothing
              }
              else {
                var hidefor =  60 * 60 * 24 * options.cookieRememberDays;
                document.cookie = "jqsa=closed;max-age=" + hidefor;
              }
            });
          });
        }
      });
    }
  });
})(jQuery);